import React from "react";
import { useTranslation } from "react-i18next";

import './easyDashboard.scss'

import AgileDashboardImg from '../../../../assets/agileDashboards/svgs/Ativo 4.svg'
import ImgSmartDashboards from "../../../../assets/interactiveDashboards/smartDashboards.png";

const EasyDashboard = () => {
    const { t } = useTranslation()

    return (
        <div className="container-easydashboard">
            <div className="texts-easydashboard">
                <h1>{t("rapid_dashboard.title")}</h1>
                <p>{t("rapid_dashboard.section_text")}</p>
                <a href="/form" style={{ textDecoration: 'none' }}>
                    <button id="btn-easydashboard">{t("buttons.more_btn_text")}</button>
                </a>
            </div>
            <div className="img-easydashboard">
                <img src={ImgSmartDashboards} alt="" />
            </div>
        </div>
    )
}

export default EasyDashboard